import * as React from 'react';
import { Text, type TextProps } from 'react-native';

import { useMergedRefs } from '@gitbook/util-react-hooks';

import { Interactive } from '../Interactive';

/**
 * A Text truncated with an tail ellipsis.
 * If the text was indeed truncated, it will show a tooltip with the full text on hover
 */
export const OneLineText = React.forwardRef<
    Text,
    React.PropsWithChildren<Omit<TextProps, 'numberOfLines'>>
>(function OneLineTextWithRef(props, ref) {
    const textRef = React.useRef<Text>(null);

    const mergedRef = useMergedRefs(textRef, ref);

    const interactive = Interactive.useInteractiveState({
        onHoverIn: () => {
            // @ts-ignore Text points to an HTMLElement
            const textElement = textRef.current as HTMLElement | undefined;

            if (textElement && textElement.scrollWidth > textElement.clientWidth) {
                const textContent = textElement.textContent;
                textElement.title = textContent || '';
            }
        },
    });

    return <Text {...props} numberOfLines={1} {...interactive.events} ref={mergedRef} />;
});
